/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import logo from '../../../../img/social/_0001_instagram.png';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const InstagramIcon = ({ className }) => (
    <img src={logo} className={className} alt="Instagram" />
);

InstagramIcon.propTypes = propTypes;
InstagramIcon.defaultProps = defaultProps;

export default InstagramIcon;
